function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSettingsUsers = function SvgSettingsUsers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.69,32.89c-1.32-.52-2.54-1-2.89-1.83a12.78,12.78,0,0,1,0-1.75v-.26A5.56,5.56,0,0,0,29,26.43a3,3,0,0,0,1.23-2.34c.09-.61-.09-.87-.53-1.05.35-1.13,1.05-4.1-.17-6a3.38,3.38,0,0,0-1-1A1.28,1.28,0,0,0,28,15.8a1.57,1.57,0,0,0-.7-.17c-.44-.79-1.49-1.14-2.89-1.14a5.65,5.65,0,0,0-4.64,1.92c-1.14,1.48-1.31,3.66-.61,6.63a1.08,1.08,0,0,0-.61,1.22,3.26,3.26,0,0,0,1.31,2.27,5.62,5.62,0,0,0,1.31,2.61v.18a12.68,12.68,0,0,1-.09,1.74c-.35.79-1.49,1.31-2.89,1.83a12.28,12.28,0,0,0-3.32,1.75A13.83,13.83,0,0,0,25,39a14,14,0,0,0,9.62-3.84A9,9,0,0,0,30.69,32.89Z",
    style: {
      fill: "#666"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettingsUsers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/settings-users.55cc2784.svg";
export { ForwardRef as ReactComponent };